import { Action } from 'redux';

import { EnterPublishedConnectionSubspace } from '~src/app/actions/AppActionTypes';
import { isActionFactory } from '~src/app/actions/isActionFactory';
import { PublishedConnectionSubspaceName } from '~src/app/state/SpaceInfo';
import { IPublishedConnectionDetailInfo } from '~src/ts/models/IPublishedConnectionInfo';

export interface EnterPublishedConnectionSubspaceReduxAction extends Action {
  readonly publishedConnectionDetailInfo: IPublishedConnectionDetailInfo;
  readonly subspaceName: PublishedConnectionSubspaceName;
  readonly requestContent: boolean;
}

export function enterPublishedConnectionSubspace(
  publishedConnectionDetailInfo: IPublishedConnectionDetailInfo,
  subspaceName: PublishedConnectionSubspaceName,
  requestContent: boolean,
): EnterPublishedConnectionSubspaceReduxAction {
  return {
    type: EnterPublishedConnectionSubspace,
    publishedConnectionDetailInfo,
    subspaceName,
    requestContent
  };
}

export const isEnterPublishedConnectionSubspaceAction = isActionFactory<EnterPublishedConnectionSubspaceReduxAction>(EnterPublishedConnectionSubspace);
